(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-new-product"]) return;
  try {
    
  var loadMoreButton = document.querySelector('.usp_content .load_more');
  loadMoreButton.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('.usp_content .usp_content_wrapper').classList.toggle('show_usp');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-product-ad-backup"]) return;
  try {
    
  // var loadMoreButton = document.querySelector('.usp_content .load_more');
  // loadMoreButton.addEventListener('click', function (e) {
  //   e.preventDefault();
  //   document.querySelector('.usp_content .usp_content_wrapper').classList.toggle('show_usp');
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-product-ad"]) return;
  try {
    
  // var loadMoreButton = document.querySelector('.usp_content .load_more');
  // loadMoreButton.addEventListener('click', function (e) {
  //   e.preventDefault();
  //   document.querySelector('.usp_content .usp_content_wrapper').classList.toggle('show_usp');
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-standard-product"]) return;
  try {
    
  // var loadMoreButton = document.querySelector('.usp_content .load_more');
  // loadMoreButton.addEventListener('click', function (e) {
  //   e.preventDefault();
  //   document.querySelector('.usp_content .usp_content_wrapper').classList.toggle('show_usp');
  // });

  } catch(e) { console.error(e); }
})();
})();
